export default {
  fields: {
    discount: {
      label: 'Rabatt',
    },
    usage_threshold: {
      label: 'Mindestbestellwert',
    },
    max_discount: {
      label: 'Maximaler Rabattbetrag',
    },
  },
};
